import { createSelector } from 'reselect';
import { dataSelector } from './dataSelector';

export const buyingToolsListSelector = createSelector(
  dataSelector,
  data => data?.buyingToolsIngredients ?? [],
);
